import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, MessageSquare } from 'lucide-react';
export function AISection() {
  const prompts = ['What caused revenue to drop this week?', 'Which campaign is wasting money?', 'What changed this month?', 'What should I stop doing?', 'What deserves more budget?'];
  return <section className="py-32 bg-secondary/30 border-y border-white/5" data-id="element-17">
      <div className="max-w-7xl mx-auto px-6" data-id="element-18">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-19">
          <div data-id="element-20">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-panel text-sm text-accent mb-8" data-id="element-21">
              <Sparkles size={16} data-id="element-22" />
              <span data-id="element-23">Coming Soon</span>
            </motion.div>
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-4xl md:text-5xl font-bold mb-6" data-id="element-24">
              Soon, your dashboard won't just report.
              <br data-id="element-25" />
              <span className="text-textSecondary" data-id="element-26">It'll think.</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-lg text-textSecondary mb-8" data-id="element-27">
              Ask in plain English. Get answers in charts.
            </motion.p>
          </div>

          <div className="relative" data-id="element-28">
            <div className="absolute inset-0 bg-accent/5 blur-[100px] rounded-full" data-id="element-29" />
            <div className="relative glass-panel rounded-2xl p-6 space-y-4" data-id="element-30">
              {prompts.map((prompt, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3 + i * 0.1
            }} className="bg-card border border-white/5 rounded-xl p-4 flex items-start gap-4" data-id="element-31">
                  <div className="w-8 h-8 rounded-full bg-secondary flex items-center justify-center shrink-0 mt-1" data-id="element-32">
                    <MessageSquare size={14} className="text-textSecondary" data-id="element-33" />
                  </div>
                  <div data-id="element-34">
                    <div className="text-sm text-white mb-3" data-id="element-35">"{prompt}"</div>
                    {i === 0 && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} whileInView={{
                  opacity: 1,
                  height: 'auto'
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 1
                }} className="bg-secondary rounded-lg p-4 text-xs text-textSecondary" data-id="element-36">
                        <div className="flex items-end gap-2 h-16 mb-2" data-id="element-37">
                          {[40, 30, 20, 10].map((h, j) => <div key={j} className="flex-1 bg-accent/60 rounded-t-sm" style={{
                      height: `${h}%`
                    }} data-id="element-38" />)}
                        </div>
                        Revenue dropped 12% primarily due to a decrease in Meta
                        Ads ROAS starting Tuesday.
                      </motion.div>}
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}